import React, { FC }                                                                                                             from 'react';
import * as Yup                                                                                                                  from "yup";
import { Cell, Grid }                                                                                                            from "styled-css-grid";
import { ActivityCriticalityDropdown }                                                                                           from "@src/views/components/forms";
import { BulkUpdateFormControlContainer }                                                                                        from "@src/views/pages/projects/activities/bulk/BulkUpdateFormControlContainer";
import { StaticProjectActivityBulkUpdateShell, StaticProjectActivityBulkUpdateShellFormContainerProps, StaticProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/StaticProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                                                             from "@src/views/pages/projects/operations/StaticProjectActivityBulkUpdateMultiDialog";
import { ACTIVITY_CRITICALITY, ENTITY_ICONS }                                                                                    from "@src/constants";
import _                                                                                                                         from "underscore";
import { useFeatureFlags }                                                                                                       from "@src/hooks";


type FormTypeAttributes = {
    criticality: ACTIVITY_CRITICALITY,
}

const formDefaultValues = {
    criticality: null,
}

const validationSchema = (
    Yup.object().shape( {
        criticality: Yup.string().nullable()
    } )
)

const mutationAttributeFormatter: StaticProjectActivityBulkUpdateShellProps<FormTypeAttributes>['prepareFormValuesForMutation'] = ( values, formik ) => {

    const { criticality } = values

    const changes: Record<any, any> = {};

    if( !_.isEmpty( criticality ) ){
        changes.criticality = criticality;
    }

    return changes;
}

interface StaticProjectActivityBulkUpdateCriticalityProps extends Pick<StaticProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
    Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<StaticProjectActivityBulkUpdateShellFormContainerProps>
}

const StaticProjectActivityBulkUpdateCriticalityDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<StaticProjectActivityBulkUpdateCriticalityProps>

function StaticProjectActivityBulkUpdateCriticality( _props: StaticProjectActivityBulkUpdateCriticalityProps ){

    const props = { ...StaticProjectActivityBulkUpdateCriticalityDefaultProps, ..._props };

    const featureFlags = useFeatureFlags();

    return (

        <StaticProjectActivityBulkUpdateShell<FormTypeAttributes>
            projectId={ props.projectId }
            projectVersionId={ props.projectVersionId }
            ids={ props.projectActivityIds }
            supportToasts={ props.supportToasts }
            supportModals={ props.supportModals }
            defaultFormValues={ formDefaultValues }
            validationSchema={ validationSchema }
            formContainer={ props.formContainer }
            prepareFormValuesForMutation={ mutationAttributeFormatter }>

            {/* FORM CONTENT */ }
            { ( { formik, isProcessing, isLoading } ) => {

                return (

                    <BulkUpdateFormControlContainer
                        icon={ ENTITY_ICONS.ACTIVITIES.CRITICALITY_RATING }
                        title={ 'Update Priority' }
                        description={ `Migrate the priority for multiple activities to the one specified.` }>

                        <Grid columns={ `1fr` } rows={ `auto auto` } columnGap={ "30px" } rowGap={ '30px' }>
                            <Cell>
                                <ActivityCriticalityDropdown
                                    label={ "Priority" }
                                    descriptionText={ `The general priority for which these activities should be rated.` }
                                    name={ "criticality" }
                                    disabled={ isLoading || isProcessing }/>
                            </Cell>
                        </Grid>

                    </BulkUpdateFormControlContainer>

                )
            } }

        </StaticProjectActivityBulkUpdateShell>

    );
}

export {
    StaticProjectActivityBulkUpdateCriticality,
    StaticProjectActivityBulkUpdateCriticalityDefaultProps,
    type StaticProjectActivityBulkUpdateCriticalityProps,
};
